export const pt_br = {
    'Error trying to get the approval settings': 'Erro ao tentar obter as configurações de aprovação: ',
    Loading: 'Carregando...',
    Type: 'Tipo',
    'Schedule Type': 'Tipo do agendamento',
    'Alert Rule': 'Regra de Alerta',
    'Check alert rule': 'Verifique a regra de alerta',
    The: 'A regra de alerta ',
    Asset: 'Ativo',
    Timespan: 'Intervalo de tempo',
    Frequency: 'Frequência',
    Hour: 'Hora',
    'alert rule must start with the event type': ' deve começar com o event type: ',
    'The pipes expression must contain the necessary fields for the selected report, as shown below':
        'A expressão de pipes deve conter os campos necessários para o relatório selecionado, como mostrado abaixo:',
    'Report Content Source': 'Fonte de conteúdo do relatório',
    Select: 'Selecione...',
    'Report Approval Settings': 'Configurações de aprovação de relatório',
    'Timespan delimits successive start and end dates, linked to the configured recurrence.':
        'Intervalo de tempo delimita sucessivas datas de início e fim, vinculadas à recorrência configurada.',
    Recurrence: 'Recorrência',
    'Server local time': 'Hora local do servidor: '
}
